<template>
  <div class="lawsmenu_fluid">
    <div class="lawsmenu between">
      <law-menu class="Popular_law" :list="menl" />
      <div class="essay">
        <div class="swiper">
          <el-carousel height="220px" indicator-position="none" arrow="always">
            <el-carousel-item
              v-for="(item, index) in bannerlist"
              :key="index"
              @click.native="tojump(item)"
            >
              <img :src="item.preview_pic" class="img" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="latest">
          <div class="lattit flex_start">
            最新文章<img src="../../../assets/laws/zuixin.png" />
          </div>
          <ul class="articlelist">
            <li
              class="between"
              v-for="(item, index) in cena"
              :key="index"
              @click="tojump(item)"
            >
              <div class="articletit ellipsis">
                <span>{{ item.tag }}</span
                >{{ item.title }}
              </div>
              <div class="artictime">
                {{ item.updated_at.substring(0, 10) }}
              </div>
            </li>
          </ul>
        </div>
        
      </div>
      
	  <div class="recommlaywer">
	  	<div :class="['flex','between',index%2 == 1?'layweritem':'layweritem-rev' ]" v-for="(item,index) in 3">
	  		<img src="../../../assets/home/advantage_1.png" class="avatar" >
			<div class="text flex-col">
				<span class="FontSize18 FontBlack ">徐子成律师&nbsp;<span class="FontSize14 FontGray1 ml10">专职律师</span></span>
				<div class="flex flex_start FontGray1 FontSize14 mt10">
					<i class="el-icon-phone " v-if="index%2 !== 1"></i>
					<span v-else>合肥专业律师：</span>
					<span>15233333333</span>
				</div>
			</div>
	  	</div>
		<div class="otherlist flex between wrap">
			<div class="laywerimg" v-for="item in 4">
				<img src="../../../assets/contmodeldet/law_sample.png" >
				<div class="name">
					徐子成律师
				</div>
			</div>
		</div>
	  </div>
	  
    </div>
  </div>
</template>

<script>
import lawMenu from "../components/lawMenu";
export default {
  name: "homemenubanner",
  components: { lawMenu },
  data() {
    return {
      hot_act: 0,
      menl:[],
      bannerlist: [],
      cena: [],
      rightb: [],
	  // list:[{name:'徐子成律师',phone:'1522222222',.info:'专职律师'}]
    };
  },
  beforeMount() {
    this.getmli();
    this.getban();
    this.getcenart();
    this.getrigart();
  },
  methods: {
    hotshow(index) {
      this.hot_act = index;
    },

    getmli(){
      this.$http.laws.getlawify()
      .then((res) => {
        this.menl = res.data
        console.log('this.$http.laws',res);
      })
    },

    getban() {
      this.$http.laws
        .getnewslist({
          limit: 5,
          order: "hot",
          page: 1,
        })
        .then((res) => {
          this["bannerlist"] = res.data.data;
        });
    },
    getcenart() {
      this.$http.laws
        .getnewslist({
          limit: 5,
          order: "new",
          page: 1,
        })
        .then((res) => {
          this["cena"] = res.data.data;
        });
    },
    getrigart() {
      this.$http.laws
        .getnewslist({
          limit: 6,
          order: "hot",
          page: 1,
        })
        .then((res) => {
          this["rightb"] = res.data.data;
        });
    },
    tojump(current) {
      this.$router.push({
        path: "/laws/specialdet",
        query: {
          lawonId: current.id,
        },
      });
    },
    
  },
};
</script>


<style lang="scss" scoped>
.lawsmenu_fluid {
  width: 100%;
  background-color: #f8f8f8;
  padding: 30px 0 50px;
  .lawsmenu {
    width: 1200px;
    height: 516px;
    margin: 0 auto;

    .Popular_law {
      width: 280px;
      height: 100%;
    }

    .essay {
      width: 520px;
      height: 100%;

      .swiper {
        width: 520px;
        height: 220px;
        .img {
          width: 100%;
          height: 100%;
        }

        ::v-deep .el-carousel__arrow {
          width: 24px;
          height: 32px;
          border-radius: 0;
        }
        ::v-deep .el-carousel__arrow--left {
          left: 0;
        }
        ::v-deep .el-carousel__arrow--right {
          right: 0;
        }
      }

      .latest {
		  background-color: #fff;
		  height: 276px;
        .lattit {
          margin-top: 22px;
          font-size: 22px;
          color: #333333;
		  padding: 20px 20px 0 20px;
          img {
            width: 32px;
            height: 15px;
            margin-left: 5px;
          }
        }
        .articlelist {
          padding: 0 7px;
          font-size: 16px;
          li {
            cursor: pointer;
            margin-top: 16px;
            .articletit {
              color: #333333;
              padding-right: 10px;
              span {
                padding-right: 10px;
                border-right: 1px solid #999;
                margin-right: 12px;
                color: #999999;
              }
            }
            .artictime {
              width: 100px;
              font-size: 14px;
              color: #999999;
            }
          }
        }
      }


    }
    
  }
}
.recommlaywer{
	width: 326px;
	height: 516px;
	background: #FFFFFF;
	box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.05);
	.layweritem{
		width: 290px;
		height: 72px;
		padding: 8px 22px;
		border-radius: 3px;
		flex-direction: row-reverse;
		background: url(../../../assets/laws/bg1.png) center/contain;
		margin: 0 auto;
		margin-top: 20px;
		justify-content: space-between;
	}
	.layweritem-rev{
		width: 290px;
		height: 72px;
		padding: 8px 22px;
		border-radius: 3px;
		background: url(../../../assets/laws/bg1.png) center/contain;
		margin: 0 auto;
		margin-top: 20px;
		justify-content: flex-start;
		.text{
			margin-left: 15px;
		}
	}
	.avatar{
		width: 56px;
		height: 56px;
		border-radius: 50%;
	}
	.otherlist{
		padding:10px 20px;
	}
	.laywerimg{
		position: relative;
		width: 135px;
		height: 102px;
		overflow: hidden;
		margin-bottom: 10px;
		img{
			width: 100%;
			object-fit: contain;
		}
		.name{
			position: absolute;
			width: 100%;
			height: 20px;
			bottom: 0;
			line-height: 20px;
			text-align: center;
			background-color: rgba(0,0,0,.34);
			color: #ffffff;
			font-size: 12px;
		}
	}
}
</style>